export default "__VITE_ASSET__kUJOtASX__"